import noop from 'lodash/fp/noop';
import { FC } from 'react';

import EditCardForm, { EditCardFormFields } from '../EditCardForm';
import { SubmitEditCardBlockProps } from '../SubmitEditCardBlock';
import SubscriptionModal from '../SubscriptionModal';

export type EditCreditCardModalProps = Omit<
  SubmitEditCardBlockProps,
  'formErrors' | 'onSubmit'
> & {
  onSubmit: (props: EditCardFormFields) => void;
  onModalClose?: () => void;
};

const EditCreditCardModal: FC<EditCreditCardModalProps> = ({
  onModalClose = noop,
  ...otherProps
}) => (
  <SubscriptionModal onModalClose={onModalClose}>
    <EditCardForm {...otherProps} />
  </SubscriptionModal>
);

export default EditCreditCardModal;
